module.exports = __webpack_public_path__ + "static/media/icon-strength.e6a909ec.svg";